function HttpSuccessInterceptor($rootScope, loadingIndicator) {
	return {
		response(response) {
			if (response.status === 200) {

				loadingIndicator.finishLoading();

				// Reset the reservation timer
				$rootScope.$broadcast('reset-reservation-timer');
			}

			return response;
		}
	};
}

module.exports = HttpSuccessInterceptor;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/interceptors/http-success-interceptor.js
 **/